import { styles } from './template.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as fonts } from '../../../../assets/fonts.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templatePackageModulesForm = document.createElement('template');

templatePackageModulesForm.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${fonts}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id='package-modules-form-wrapper'>
    <div id='header-settings-section'>
      <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' class='text-uppercase form-subtitle-info' id='modules-roles-subtitle'></gz-title>

      <div class='form-section'>
        <gz-form-field id='operation-mode-form-field' class='label-mw-250' label=''>
          <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-info-box id='edr-box-info' class='box-info' severity='informative'></gz-info-box>
      </div>

      <gz-toggle id='show-all-modules-toggle' class='hidden'></gz-toggle>
      <gz-info-box id='show-all-modules-info-box' class='box-info hidden' severity='warning'></gz-info-box>
    </div>

    <div class='form-section'>
      <div class='flex-group section-margin'>
        <gz-title fontSize='${FontSizes.PARAGRAPH_11}' id='modules-subtitle' fontWeight='${FontWeights.SEMIBOLD}' class='text-uppercase module-subtitle'></gz-title>
        <gz-title fontSize='${FontSizes.PARAGRAPH_11}' fontWeight='${FontWeights.SEMIBOLD}' id='os-compatibility-subtitle' class='ml-2 text-uppercase module-subtitle'></gz-title>
      </div>

      <gz-form-field id='module-antimalware' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-atc' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-aae' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip>
          <div class='module-icon'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-container-protection' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip>
          <div class='module-icon'></div>
        </gz-tooltip>
        <gz-tooltip>
          <div class='module-icon'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-firewall' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-network-protection' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-user-control' class='flex-group'>
        <gz-checkbox class='form-field-input sub-module' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-antiphishing' class='flex-group'>
        <gz-checkbox class='form-field-input sub-module' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-traffic-scan' class='flex-group'>
        <gz-checkbox class='form-field-input sub-module' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-network-attack-defense' class='flex-group'>
        <gz-checkbox class='form-field-input sub-module' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-device-control' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-power-user' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-application-control' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-encryption' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip>
          <div class='module-icon'></div>
        </gz-tooltip>
        <gz-link type='underline' id='module-encryption-info' class='module-info' fontSize='${FontSizes.PARAGRAPH_12}' color='primary'></gz-link>
      </gz-form-field>

      <gz-form-field id='module-patch-management' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-integrity-monitor' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip>
          <div class='module-icon'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-edr-sensor' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-macos-tooltip'>
          <div class='module-icon icon icon-apple'></div>
        </gz-tooltip>
        <gz-tooltip class='tooltip module-linux-tooltip'>
          <div class='module-icon icon icon-linux'></div>
        </gz-tooltip>
      </gz-form-field>

      <gz-form-field id='module-frat' class='flex-group'>
        <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
        <gz-tooltip class='tooltip module-windows-tooltip'>
          <div class='module-icon icon icon-windows'></div>
        </gz-tooltip>
      </gz-form-field>

      <div id='roles-section'>

        <div class='flex-group section-margin mt-3'>
          <gz-title fontSize='${FontSizes.PARAGRAPH_11}' id='roles-subtitle' fontWeight='${FontWeights.SEMIBOLD}' class='text-uppercase module-subtitle'></gz-title>
        </div>

        <gz-form-field id='module-update-server' class='flex-group'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
          <gz-tooltip class='tooltip module-windows-tooltip'>
            <div class='module-icon icon icon-windows'></div>
          </gz-tooltip>
          <gz-tooltip>
            <div class='module-icon'></div>
          </gz-tooltip>
          <gz-tooltip class='tooltip module-linux-tooltip'>
            <div class='module-icon icon icon-linux'></div>
          </gz-tooltip>
          <gz-link type='underline' id='module-update-server-info' class='module-info' fontSize='${FontSizes.PARAGRAPH_12}' color='primary'></gz-link>
        </gz-form-field>

        <gz-form-field id='module-patch-management-server' class='flex-group'>
          <gz-checkbox class='form-field-input sub-module' gz-form-input></gz-checkbox>
          <gz-tooltip class='tooltip module-windows-tooltip'>
            <div class='module-icon icon icon-windows'></div>
          </gz-tooltip>
          <gz-tooltip>
            <div class='module-icon'></div>
          </gz-tooltip>
          <gz-tooltip class='tooltip module-linux-tooltip'>
            <div class='module-icon icon icon-linux'></div>
          </gz-tooltip>
          <gz-link type='underline' id='module-patch-management-server-info' class='module-info' fontSize='${FontSizes.PARAGRAPH_12}' color='primary'></gz-link>
        </gz-form-field>

        <gz-form-field id='module-mail-servers' class='flex-group'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
          <gz-tooltip class='tooltip module-windows-servers-tooltip'>
            <div class='module-icon icon icon-win_vm'></div>
          </gz-tooltip>
          <gz-tooltip>
            <div class='module-icon'></div>
          </gz-tooltip>
          <gz-tooltip>
            <div class='module-icon'></div>
          </gz-tooltip>
          <gz-link type='underline' id='module-mail-servers-info' class='module-info' fontSize='${FontSizes.PARAGRAPH_12}' color='primary'></gz-link>
        </gz-form-field>

      </div>

      <gz-info-box id='modules-and-roles-validation-info-box' class='box-info hidden' severity='warning'></gz-info-box>

      <div id='additional-settings-section'>
        <div class='flex-group mt-3'>
          <gz-title fontSize='${FontSizes.PARAGRAPH_11}' id='additional-settings-subtitle' class='section-margin text-uppercase module-subtitle' fontWeight='${FontWeights.SEMIBOLD}'></gz-title>
        </div>

        <gz-form-field id='remove-competitors' class='flex-group'>
          <gz-checkbox class='form-field-input' gz-form-input></gz-checkbox>
          <gz-info-box id='remove-competitors-box-info' class='box-info' severity='warning'></gz-info-box>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
